import React from 'react';
import Counter from './Counter';
/**
 * This will copy the functionality in _fyh/src/components/filters/beds-baths.js
 * - since the dependency versions differ between FYH and Viewport Map, we
 *   are unable to reuse the functionality directly, but once the apps
 *   get consolidated, we will be able to have a single Slider component
 */
const BedsBathsFilter = ({ title, beds, bedsLabel, onBedsChange, baths, bathsLabel, onBathsChange, className }) => {
    return (React.createElement("div", { className: 'bedsBaths' + (className ? ' ' + className : '') },
        React.createElement("p", { className: "filter-title" }, title),
        React.createElement("div", { className: "bedsBaths__flex" },
            React.createElement(Counter, { label: bedsLabel, count: beds, minCount: 1, onCountChange: (count) => onBedsChange(count), className: 'viewport-map__counter' }),
            React.createElement(Counter, { label: bathsLabel, count: baths, minCount: 1, onCountChange: (count) => onBathsChange(count), className: 'viewport-map__counter' }))));
};
export default BedsBathsFilter;
